/* Dorabella – taglia obbligatoria.
   Se la cliente non ha una taglia salvata ("La mia taglia") e non arriva da un link con ?variant=,
   la taglia non risulta scelta finché non la clicca: il bottone "Aggiungi al carrello" chiede prima la taglia.
   Riduce i resi per taglia sbagliata (taglia preselezionata di default). */
(function () {
  var SIZE_RE = /taglia|size/i;
  var chosen = false;
  try { chosen = !!localStorage.getItem('dora_my_size_v2'); } catch (e) {}
  if (/[?&]variant=/.test(location.search)) chosen = true;

  function sizeInputs(root) {
    return Array.prototype.filter.call((root || document).querySelectorAll('variant-selects input[type=radio]'), function (i) {
      return SIZE_RE.test(i.name || '');
    });
  }
  function sizeFieldset() {
    var inputs = sizeInputs();
    if (!inputs.length) return null;
    var values = {};
    inputs.forEach(function (i) { values[i.value] = 1; });
    if (Object.keys(values).length < 2) return null; // taglia unica
    return inputs[0].closest('fieldset');
  }
  function mark() {
    var fs = sizeFieldset();
    if (!fs) { chosen = true; return; }
    fs.classList.toggle('dora-size-unchosen', !chosen);
    if (chosen) {
      fs.classList.remove('dora-size-error');
      var m = fs.querySelector('.dora-size-msg'); if (m) m.remove();
    }
  }
  function markChosen() { chosen = true; mark(); }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('variant-selects input[type=radio]') && SIZE_RE.test(e.target.name || '')) markChosen();
  }, true);
  document.addEventListener('click', function (e) {
    var l = e.target && e.target.closest && e.target.closest('variant-selects label');
    if (!l) return;
    var id = l.getAttribute('for');
    var inp = id && document.getElementById(id);
    if (inp && SIZE_RE.test(inp.name || '')) markChosen();
  }, true);
  document.addEventListener('submit', function (e) {
    if (chosen) return;
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var fs = sizeFieldset();
    if (!fs) return;
    var pf = form.closest('product-form');
    if (pf && pf.closest('.quick-add-modal, quick-add-modal')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fs.classList.add('dora-size-error');
    if (!fs.querySelector('.dora-size-msg')) {
      var p = document.createElement('p');
      p.className = 'dora-size-msg';
      p.setAttribute('role', 'alert');
      p.textContent = 'Seleziona la tua taglia';
      fs.appendChild(p);
    }
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  function init() {
    mark();
    // il selettore varianti viene ridisegnato al cambio colore: riapplico lo stato
    var target = document.querySelector('variant-selects');
    if (target && window.MutationObserver) {
      new MutationObserver(function () { mark(); }).observe(target.parentNode || target, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
